module.exports = __webpack_public_path__ + "img/huoban5.54902a75.png";